/**
 * Cookies manipulation
 */
class Cookie {
  /**
   * Возвращает cookie с именем name, если есть, если нет, то undefined
   * @param {String} name
   * @return {String|undefined}
   */
  static get(name) {
    const regexp = new RegExp(
      `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`
    );

    const matches = document.cookie.match(regexp);

    return matches
      ? decodeURIComponent(matches[1])
      : undefined;
  }

  /**
   * Устанавливает cookie с именем name и значением value
   * options - объект с свойствами cookie (expires, path, domain, secure)
   * @param {String} name
   * @param {String} value
   * @param {Object} options
   */
  static set(name, value, options) {
    options = options || {};

    let expires = options.expires;

    if (typeof expires == 'number' && expires) {
      const d = new Date();
      d.setTime(d.getTime() + expires * 1000);
      expires = options.expires = d;
    }

    if (expires && expires.toUTCString) {
      options.expires = expires.toUTCString();
    }

    value = encodeURIComponent(value);

    let updatedCookie = `${name}=${value}`;

    for (let propName in options) {
      if (options.hasOwnProperty(propName)) {
        updatedCookie += `; ${propName}`;

        let propValue = options[propName];

        if (propValue !== true) {
          updatedCookie += `=${propValue}`;
        }
      }
    }

    document.cookie = updatedCookie;
  }

  /**
   * @param {String} name
   */
  static delete(name) {
    setCookie(name, '', {
      expires: -1,
    });
  }
};

export default Cookie;



// WEBPACK FOOTER //
// ./src/js/Cookie.js